import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Spinner from "./utils/Spinner";

const Welcome = React.lazy(() => import("./pages/Welcome"));
const Batons = React.lazy(() => import("./pages/Batons"));
const BatonDetails = React.lazy(() => import("./pages/BatonDetails"));
const Settings = React.lazy(() => import("./pages/Settings"));

const ProtectedRoutes = () => {
	return (
		<Suspense fallback={<Spinner />}>
			<Routes>
				<Route path='/welcome' element={<Welcome />} />
				<Route path='/batons' element={<Batons />} />
				<Route path='/batons/:id' element={<BatonDetails />} />
				<Route path='/settings/:tab' element={<Settings />} />
			</Routes>
		</Suspense>
	);
};

export const PROTECTED_ROUTES = ["/welcome", "/batons", "/batons/:id"];

export default ProtectedRoutes;
